export default __webpack_public_path__ + "static/media/trazo_flecha_derecha.1a873edc.png";